
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.186 20.25a1.735 1.735 0 013.022.437 1.72 1.72 0 01-.464 1.862 1.737 1.737 0 01-1.903.288 1.726 1.726 0 01-.992-1.642c.016-.34.133-.67.337-.944zM10.19 16.992l11.167-3.444a1.157 1.157 0 011.477.69 1.147 1.147 0 01-.695 1.475l-11.167 3.443c-.834.3-1.751.271-2.563-.082A3.442 3.442 0 016.558 14.7a3.464 3.464 0 011.727-1.893L4.258 7.237l-.002-.006-.382-.528a1.157 1.157 0 00-1.328-.408l-1 .36a1.158 1.158 0 01-1.478-.69A1.148 1.148 0 01.763 4.49l1.001-.36a3.482 3.482 0 012.09-.075c.688.19 1.3.586 1.753 1.136l1.42 1.934 3.505 4.851 6.318-1.637a1.161 1.161 0 00.76-1.162l-.344-5.103-.149-1.796a1.179 1.179 0 112.354-.167l.444 6.908a3.463 3.463 0 01-.56 2.12 3.485 3.485 0 01-1.723 1.364l-8.224 2.324a1.148 1.148 0 00-.1 2.124c.277.13.594.144.882.04zM19.876 18.119a1.736 1.736 0 012.13-.54 1.724 1.724 0 01-.48 3.27 1.736 1.736 0 01-1.741-.814 1.72 1.72 0 01.09-1.916z","fill":"currentColor"}}),_c('rect',{attrs:{"y":"13","width":"6","height":"2","rx":"1","fill":"currentColor"}}),_c('rect',{attrs:{"x":"2","y":"16","width":"3","height":"2","rx":"1","fill":"currentColor"}})])
          )
        }
      }
    